import React, { useMemo } from 'react';
import { RibbonOverlay } from './RibbonOverlay';
import { CircuitOverlay } from './CircuitOverlay';
import { SineWaveOverlay } from './SineWaveOverlay';
import { NeuralNetworkOverlay } from './NeuralNetworkOverlay';

type OverlayType = 'ribbon' | 'circuit' | 'sinewave' | 'neural';

type ComponentType = React.FC;

const overlayComponents: Record<OverlayType, ComponentType> = {
  ribbon: RibbonOverlay,
  circuit: CircuitOverlay,
  sinewave: SineWaveOverlay,
  neural: NeuralNetworkOverlay,
};

const overlayTypes: OverlayType[] = Object.keys(overlayComponents) as OverlayType[];

export function RandomOverlay() {
  const SelectedOverlay = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * overlayTypes.length);
    return overlayComponents[overlayTypes[randomIndex]];
  }, []);

  return <SelectedOverlay />;
}

export { RibbonOverlay, CircuitOverlay, SineWaveOverlay, NeuralNetworkOverlay };
